import { Badge } from '../ui/Badge';
import { STATUS_LABELS, STATUS_COLORS, STATUS_DOT, PRIORITY_LABELS, PRIORITY_COLORS } from '../../utils/constants';

export function StatusBadge({ status }) {
  return (
    <Badge className={STATUS_COLORS[status]}>
      <span className={`w-1.5 h-1.5 rounded-full ${STATUS_DOT[status]}`} />
      {STATUS_LABELS[status]}
    </Badge>
  );
}

export function PriorityBadge({ priority }) {
  return (
    <Badge className={PRIORITY_COLORS[priority]}>
      {priority === 'urgent' && '🔴 '}
      {PRIORITY_LABELS[priority]}
    </Badge>
  );
}
